"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fractionDependencies = void 0;

var _dependenciesFractionClassGenerated = require("./dependenciesFractionClass.generated.js");

var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var fractionDependencies = {
  FractionDependencies: _dependenciesFractionClassGenerated.FractionDependencies,
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createFraction: _factoriesAny.createFraction
};
exports.fractionDependencies = fractionDependencies;